import { CardPresentation, Pointer } from '@yleisradio/areena-types';
import type { TargetedMouseEvent } from 'preact';
import { hbbTvMode, Mode } from '../../common/types';

export const preventAccess = (e: TargetedMouseEvent<HTMLElement>) => {
  e.preventDefault();
  e.stopPropagation();
};

export const isBroadcastCardAndHbbtv = (
  presentation: CardPresentation | undefined,
  mode: Mode
) => mode === hbbTvMode && presentation === 'broadcastCard';

export const isServicePointerAndHbbtv = (pointer: Pointer, mode: Mode) =>
  mode === hbbTvMode && pointer.uri.includes('service');
